module.exports = __webpack_public_path__ + "img/cmbc.7e9afab0.png";